// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Chapter, Progress } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

interface IltCourseContentState {
  iltCourseContents: { [key: string]: Chapter[] };
  iltCourseProgress: { [key: string]: Progress[] };
  isLoading: boolean;
  isUpdateProgressLoading: boolean;
  error?: Error;
  noteError?: Error;
  progressError?: Error;
}

const {
  getIltCourseContentsDataActions,
  updateIltCourseProgressActions,
} = actionCreatorsList;

export const initialState: IltCourseContentState = {
  iltCourseContents: {},
  iltCourseProgress: {},
  isLoading: true,
  isUpdateProgressLoading: false
};

const iltCourseContentsDataReducer = (state = initialState, action: RootAction):IltCourseContentState => {
  switch (action.type) {
    case getType(getIltCourseContentsDataActions.request): {
      const { preventLoading = false } = action.payload;
      return {
        ...state,
        isLoading: !preventLoading,
        error: undefined
      };
    }
    case getType(getIltCourseContentsDataActions.success): {
      const { payload } = action;
      const {
        id,
        chapters,
        progress,
      } = payload;

      return {
        ...state,
        isLoading: false,
        iltCourseContents: { [id]: chapters },
        iltCourseProgress: { [id]: progress },
      };
    }
    case getType(getIltCourseContentsDataActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    case getType(updateIltCourseProgressActions.request): {
      return {
        ...state,
        isUpdateProgressLoading: true,
        progressError: undefined
      };
    }
    case getType(updateIltCourseProgressActions.success): {
      const {
        id,
        progress
      } = action.payload;

      return {
        ...state,
        isUpdateProgressLoading: false,
        iltCourseProgress: { [id]: progress },
      };
    }
    case getType(updateIltCourseProgressActions.failure): {
      return {
        ...state,
        isUpdateProgressLoading: false,
        progressError: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export {iltCourseContentsDataReducer as default};
